// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.complete-user-info__title.baloa-table {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
    text-align: center;
    margin-top: var(--space-and-half);
}

.complete-user-info__img-title.baloa-table {
    color: var(--primary-dark-color);
    font-weight: var(--font-medium);
    text-align: center;
    margin-top: var(--space-and-half);
    margin-bottom: var(--space-quarter);
}

.complete-user-info__form {
    padding: 0 56px;
    /* display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column; */
}

.complete-user-info__container .modal2__container {
    width: 630px;
}

.complete-user-info__container .modal2__header__close {
    display: none;
}

.complete-user-info__upload-img__container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-bottom: var(--space);
}

.complete-user-info__upload-img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--new-input-background-color);
}

.complete-user-info__upload-img .hubicon-default_pp{
    font-size: 100px;
}

.complete-user-info__upload-img__upload.baloa-names {
    color: var(--new-green-color);
    text-align: center;
    margin-top: var(--space-quarter);
    cursor: pointer;
}

.complete-user-info__form__username .input-field {
    margin-bottom: var(--space-quarter);
}

.complete-user-info__form__username__example.baloa-names {
    color: var(--new-green-color);
    font-weight: var(--font-regular);
}

.complete-user-info__form__username__exampleSubtitle.baloa-names{
    color: var(--primary-dark-color);
    font-weight: var(--font-regular);
}

.complete-user-info__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: var(--space-and-half);
    padding: var(--space);
    border-top: 1px solid var(--new-input-background-color);
    margin-top: var(--space-and-half);
}

.complete-user-info__actions .button {
    font-size: var(--space);
    line-height: calc(var(--space) + var(--space-eighth) + 1px);
}

.complete-user-info__actions .secondary-button {
    font-size: var(--space);
    line-height: calc(var(--space) + var(--space-eighth) + 1px);
    padding: calc( var(--space-half) + var(--space-eighth) ) var(--space-and-half);
}

.complete-user-info__actions .secondary-button {
    border: none;
    color: var(--primary-dark-color);
}

.complete-user-info__actions .secondary-button:hover {
    background-color: unset;
}

.complete-user-info__upload-img img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
}

.complete-user-info__container.modal2 {
    z-index: 998;
}

.complete-user-info__upload-img__modal.modal2 {
    z-index: 999;
}

.complete-user-info__form__col {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    gap: 24px;
}

.complete-user-info__form__col .input-field {
    margin: var(--space-x3) 0 0 0;
}

.complete-user-info__form__col .input-field-input {
    width: 248px;
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.complete-user-info__form__col .input-field-label{
    color: var(--primary-dark-color);
    font-weight: var(--font-medium);
    font-size: var(--space);
    text-transform: inherit;
}

.complete-user-info__form__role_container{
    width: 100%;
    display: flex;
    justify-content: flex-start;
    gap: 24px;
}

.complete-user-info__form__profile-role,
.complete-user-info__form__profile-profession-type{
    width: 50%;
}

.complete-user-info__form__profile-role .select-field.profile-role-selector__select-input{
    margin: 0;
}

.complete-user-info__form__profile-profession-type .search_members_staff_edit_content .input-field-autocomplete .MuiInputBase-root{
    border: 1.5px solid var(--new-gray-background-color);
    border-radius: 9px;
}

.complete-user-info__form__profile-profession-type .MuiFormLabel-root{
    color: var(--primary-dark-color);
    font-weight: var(--font-medium);
    font-size: var(--space);
    text-transform: inherit;
}

.complete-user-info__form__profile-profession-type{
    margin-top: 11px;
}

.complete-user-info__form__profile-role_label_tooltip{
    display: flex;
    gap: var(--space-quarter);
    align-items: center;
}

.complete-user-info__form__profile-role_label_tooltip .label_tooltip.baloa-table{
    color: var(--primary-dark-color);
    font-weight: var(--font-medium);
}

.complete-user-info__form__input_grid-tooltip{
    display: flex;
}

.complete-user-info_tooltip {
    position: relative;
    display: inline-block;
}

.complete-user-info_tooltip .complete-user-info_tooltiptext {
    display:flex;
    flex-direction: column;
    align-items: flex-start;
    visibility: hidden;
    width: 20rem;
    background: var(--white-color);
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    border-radius: 6px;
    padding: 10px;
    position: absolute;
    left: -62px;
    top: -192px;
    z-index: 1;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));
}

.complete-user-info_tooltip:hover{
    cursor: pointer;
}

.complete-user-info_tooltip:hover .complete-user-info_tooltiptext {
    visibility: visible;
}

.complete-user-info_tooltiptext .baloa-username{
    color: var(--primary-dark-color);
}

.complete-user-info_tooltiptext .baloa-table{
    color: var(--primary-dark-color);
    margin-bottom: var(--space-half);
    margin-left: var(--space-quarter);
}

.complete-user-info_tooltiptext_grid_title{
    display: flex;
    align-items: baseline;
}

.complete-user-info_profile-photo__container_plus{
    background-color: var(--new-green-color);
    width: 31px;
    height: 31px;
    border-radius: 50%;
    position: absolute;
    top: 74%;
    left: 53%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.complete-user-info_profile-photo__container_plus.baloa-subtitle-2{
    color: var(--white-color);
    font-weight: var(--font-medium);
}

.complete-user-info_profile-photo__container_plus:hover{
    cursor: pointer;
}

.complete-user-info_tooltip .complete-user-info_tooltiptext::after{
    content: "";
    position: absolute;
    bottom: -10px;
    left: 22%;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid var(--white-color);
    transform: translateX(-50%);
}

.complete-user-info__form__profile-profession-type .MuiAutocomplete-listbox{
    padding: 8px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .complete-user-info__container .modal2__container {
        width: 100%;
        margin: 0;
        border-radius: 0;
        max-height: 100%;
        height: 100%;
    }

    .complete-user-info__container .modal2__content {
        height: 100%;
        overflow: scroll;
    }

    .complete-user-info__form {
        padding: 0 16px;        
    }

    .complete-user-info__form__col {
        flex-direction: column;
        gap: 0;
    }

    .complete-user-info__form__col .input-field {
        margin: var(--space-x3) 0 0 0;
    }

    .complete-user-info__title.baloa-table {
        text-align: left;
        padding: 0 16px;
    }

    .complete-user-info__container .modal2__header {
        padding: 24px 16px 0 16px;
    }

    .complete-user-info__container .form {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .complete-user-info__actions {
        flex-direction: column-reverse;
        padding: 16px;
        gap: 0;
    }

    .complete-user-info__actions .button {
        width: 100%;
        display: block;
    }

    .complete-user-info__actions .secondary-button {
        padding: 12px;
    }
    .complete-user-info__form__col .input-field-input {
        width: 100%;
    }
    .complete-user-info_profile-photo__container_plus{
        top: 71px;
        left: 215px;
    }
    .complete-user-info__form__role_container{
        flex-direction: column;
    }
    .complete-user-info__form__profile-role{
        width: 100%;
    }
    .complete-user-info__form__profile-profession-type{
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/authentication/components/complete-user-info-modal/CompleteUserInfoModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,+BAA+B;IAC/B,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,kBAAkB;IAClB,iCAAiC;IACjC,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf;;;6BAGyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mDAAmD;AACvD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,0BAA0B;IAC1B,qBAAqB;IACrB,uDAAuD;IACvD,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;IACvB,2DAA2D;AAC/D;;AAEA;IACI,uBAAuB;IACvB,2DAA2D;IAC3D,8EAA8E;AAClF;;AAEA;IACI,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,SAAS;AACb;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oDAAoD;IACpD,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,8BAA8B;IAC9B,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,UAAU;IACV,oDAAoD;AACxD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,wCAAwC;IACxC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,mCAAmC;IACnC,oCAAoC;IACpC,yCAAyC;IACzC,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,WAAW;QACX,SAAS;QACT,gBAAgB;QAChB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,MAAM;IACV;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;QAC9B,aAAa;QACb,MAAM;IACV;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;IACA;QACI,WAAW;IACf;IACA;QACI,SAAS;QACT,WAAW;IACf;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;AACJ","sourcesContent":[".complete-user-info__title.baloa-table {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n    text-align: center;\n    margin-top: var(--space-and-half);\n}\n\n.complete-user-info__img-title.baloa-table {\n    color: var(--primary-dark-color);\n    font-weight: var(--font-medium);\n    text-align: center;\n    margin-top: var(--space-and-half);\n    margin-bottom: var(--space-quarter);\n}\n\n.complete-user-info__form {\n    padding: 0 56px;\n    /* display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column; */\n}\n\n.complete-user-info__container .modal2__container {\n    width: 630px;\n}\n\n.complete-user-info__container .modal2__header__close {\n    display: none;\n}\n\n.complete-user-info__upload-img__container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    margin-bottom: var(--space);\n}\n\n.complete-user-info__upload-img {\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: var(--new-input-background-color);\n}\n\n.complete-user-info__upload-img .hubicon-default_pp{\n    font-size: 100px;\n}\n\n.complete-user-info__upload-img__upload.baloa-names {\n    color: var(--new-green-color);\n    text-align: center;\n    margin-top: var(--space-quarter);\n    cursor: pointer;\n}\n\n.complete-user-info__form__username .input-field {\n    margin-bottom: var(--space-quarter);\n}\n\n.complete-user-info__form__username__example.baloa-names {\n    color: var(--new-green-color);\n    font-weight: var(--font-regular);\n}\n\n.complete-user-info__form__username__exampleSubtitle.baloa-names{\n    color: var(--primary-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.complete-user-info__actions {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: var(--space-and-half);\n    padding: var(--space);\n    border-top: 1px solid var(--new-input-background-color);\n    margin-top: var(--space-and-half);\n}\n\n.complete-user-info__actions .button {\n    font-size: var(--space);\n    line-height: calc(var(--space) + var(--space-eighth) + 1px);\n}\n\n.complete-user-info__actions .secondary-button {\n    font-size: var(--space);\n    line-height: calc(var(--space) + var(--space-eighth) + 1px);\n    padding: calc( var(--space-half) + var(--space-eighth) ) var(--space-and-half);\n}\n\n.complete-user-info__actions .secondary-button {\n    border: none;\n    color: var(--primary-dark-color);\n}\n\n.complete-user-info__actions .secondary-button:hover {\n    background-color: unset;\n}\n\n.complete-user-info__upload-img img {\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n}\n\n.complete-user-info__container.modal2 {\n    z-index: 998;\n}\n\n.complete-user-info__upload-img__modal.modal2 {\n    z-index: 999;\n}\n\n.complete-user-info__form__col {\n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n    gap: 24px;\n}\n\n.complete-user-info__form__col .input-field {\n    margin: var(--space-x3) 0 0 0;\n}\n\n.complete-user-info__form__col .input-field-input {\n    width: 248px;\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.complete-user-info__form__col .input-field-label{\n    color: var(--primary-dark-color);\n    font-weight: var(--font-medium);\n    font-size: var(--space);\n    text-transform: inherit;\n}\n\n.complete-user-info__form__role_container{\n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n    gap: 24px;\n}\n\n.complete-user-info__form__profile-role,\n.complete-user-info__form__profile-profession-type{\n    width: 50%;\n}\n\n.complete-user-info__form__profile-role .select-field.profile-role-selector__select-input{\n    margin: 0;\n}\n\n.complete-user-info__form__profile-profession-type .search_members_staff_edit_content .input-field-autocomplete .MuiInputBase-root{\n    border: 1.5px solid var(--new-gray-background-color);\n    border-radius: 9px;\n}\n\n.complete-user-info__form__profile-profession-type .MuiFormLabel-root{\n    color: var(--primary-dark-color);\n    font-weight: var(--font-medium);\n    font-size: var(--space);\n    text-transform: inherit;\n}\n\n.complete-user-info__form__profile-profession-type{\n    margin-top: 11px;\n}\n\n.complete-user-info__form__profile-role_label_tooltip{\n    display: flex;\n    gap: var(--space-quarter);\n    align-items: center;\n}\n\n.complete-user-info__form__profile-role_label_tooltip .label_tooltip.baloa-table{\n    color: var(--primary-dark-color);\n    font-weight: var(--font-medium);\n}\n\n.complete-user-info__form__input_grid-tooltip{\n    display: flex;\n}\n\n.complete-user-info_tooltip {\n    position: relative;\n    display: inline-block;\n}\n\n.complete-user-info_tooltip .complete-user-info_tooltiptext {\n    display:flex;\n    flex-direction: column;\n    align-items: flex-start;\n    visibility: hidden;\n    width: 20rem;\n    background: var(--white-color);\n    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\n    border-radius: 8px;\n    border-radius: 6px;\n    padding: 10px;\n    position: absolute;\n    left: -62px;\n    top: -192px;\n    z-index: 1;\n    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));\n}\n\n.complete-user-info_tooltip:hover{\n    cursor: pointer;\n}\n\n.complete-user-info_tooltip:hover .complete-user-info_tooltiptext {\n    visibility: visible;\n}\n\n.complete-user-info_tooltiptext .baloa-username{\n    color: var(--primary-dark-color);\n}\n\n.complete-user-info_tooltiptext .baloa-table{\n    color: var(--primary-dark-color);\n    margin-bottom: var(--space-half);\n    margin-left: var(--space-quarter);\n}\n\n.complete-user-info_tooltiptext_grid_title{\n    display: flex;\n    align-items: baseline;\n}\n\n.complete-user-info_profile-photo__container_plus{\n    background-color: var(--new-green-color);\n    width: 31px;\n    height: 31px;\n    border-radius: 50%;\n    position: absolute;\n    top: 74%;\n    left: 53%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.complete-user-info_profile-photo__container_plus.baloa-subtitle-2{\n    color: var(--white-color);\n    font-weight: var(--font-medium);\n}\n\n.complete-user-info_profile-photo__container_plus:hover{\n    cursor: pointer;\n}\n\n.complete-user-info_tooltip .complete-user-info_tooltiptext::after{\n    content: \"\";\n    position: absolute;\n    bottom: -10px;\n    left: 22%;\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    border-top: 10px solid var(--white-color);\n    transform: translateX(-50%);\n}\n\n.complete-user-info__form__profile-profession-type .MuiAutocomplete-listbox{\n    padding: 8px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .complete-user-info__container .modal2__container {\n        width: 100%;\n        margin: 0;\n        border-radius: 0;\n        max-height: 100%;\n        height: 100%;\n    }\n\n    .complete-user-info__container .modal2__content {\n        height: 100%;\n        overflow: scroll;\n    }\n\n    .complete-user-info__form {\n        padding: 0 16px;        \n    }\n\n    .complete-user-info__form__col {\n        flex-direction: column;\n        gap: 0;\n    }\n\n    .complete-user-info__form__col .input-field {\n        margin: var(--space-x3) 0 0 0;\n    }\n\n    .complete-user-info__title.baloa-table {\n        text-align: left;\n        padding: 0 16px;\n    }\n\n    .complete-user-info__container .modal2__header {\n        padding: 24px 16px 0 16px;\n    }\n\n    .complete-user-info__container .form {\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n    }\n\n    .complete-user-info__actions {\n        flex-direction: column-reverse;\n        padding: 16px;\n        gap: 0;\n    }\n\n    .complete-user-info__actions .button {\n        width: 100%;\n        display: block;\n    }\n\n    .complete-user-info__actions .secondary-button {\n        padding: 12px;\n    }\n    .complete-user-info__form__col .input-field-input {\n        width: 100%;\n    }\n    .complete-user-info_profile-photo__container_plus{\n        top: 71px;\n        left: 215px;\n    }\n    .complete-user-info__form__role_container{\n        flex-direction: column;\n    }\n    .complete-user-info__form__profile-role{\n        width: 100%;\n    }\n    .complete-user-info__form__profile-profession-type{\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
